'use client';

import { useGlobalContext } from '@/store/contexts/global-context';
import type { LauncherUrlResolutionContext } from '@/utils/url/launcher-url';

/** Pre-resolved values for `getLauncherUrl` / `resolveClgUrl`. */
export const useLauncherUrlResolution = (): LauncherUrlResolutionContext => {
    return useGlobalContext().launcherUrlResolution;
};
